import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import type { ApiDropPart } from "@/generated/models/ApiDropPart";
import type { ApiDropMentionedUser } from "@/generated/models/ApiDropMentionedUser";
import type { ApiMentionedWave } from "@/generated/models/ApiMentionedWave";
import WaveDropPartTitle from "./WaveDropPartTitle";
import WaveDropPartContent from "./WaveDropPartContent";
import { ImageScale } from "@/helpers/image.helpers";
interface WaveDropPartDropProps {
  drop: ApiDrop;
  activePart: ApiDropPart;
  havePreviousPart: boolean;
  haveNextPart: boolean;
  isStorm: boolean;
  activePartIndex: number;
  setActivePartIndex: (index: number) => void;
  onQuoteClick: (drop: ApiDrop) => void;
  isEditing?: boolean | undefined;
  isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string, mentions?: ApiDropMentionedUser[], mentionedWaves?: ApiMentionedWave[]) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  isCompetitionDrop?: boolean | undefined;
  mediaImageScale?: ImageScale | undefined;
  fullWidthMedia?: boolean | undefined;
  readonly onLinkCardActionsActiveChange?: ((href: string, active: boolean) => void) | undefined;
}
const WaveDropPartDrop: React.FC<WaveDropPartDropProps> = t0 => {
  const $ = _c(22);
  const {
    drop,
    activePart,
    havePreviousPart,
    haveNextPart,
    isStorm,
    activePartIndex,
    setActivePartIndex,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4,
    fullWidthMedia: t5,
    onLinkCardActionsActiveChange
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  const fullWidthMedia = t5 === undefined ? false : t5;
  let t6;
  if ($[0] !== drop.title) {
    t6 = <WaveDropPartTitle title={drop.title} />;
    $[0] = drop.title;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== activePart || $[3] !== activePartIndex || $[4] !== drop || $[5] !== fullWidthMedia || $[6] !== haveNextPart || $[7] !== havePreviousPart || $[8] !== isCompetitionDrop || $[9] !== isEditing || $[10] !== isSaving || $[11] !== isStorm || $[12] !== mediaImageScale || $[13] !== onCancel || $[14] !== onLinkCardActionsActiveChange || $[15] !== onQuoteClick || $[16] !== onSave || $[17] !== setActivePartIndex) {
    t7 = <WaveDropPartContent mentionedUsers={drop.mentioned_users} mentionedWaves={drop.mentioned_waves} referencedNfts={drop.referenced_nfts} wave={drop.wave} activePart={activePart} havePreviousPart={havePreviousPart} haveNextPart={haveNextPart} isStorm={isStorm} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onQuoteClick={onQuoteClick} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} drop={drop} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} fullWidthMedia={fullWidthMedia} onLinkCardActionsActiveChange={onLinkCardActionsActiveChange} />;
    $[2] = activePart;
    $[3] = activePartIndex;
    $[4] = drop;
    $[5] = fullWidthMedia;
    $[6] = haveNextPart;
    $[7] = havePreviousPart;
    $[8] = isCompetitionDrop;
    $[9] = isEditing;
    $[10] = isSaving;
    $[11] = isStorm;
    $[12] = mediaImageScale;
    $[13] = onCancel;
    $[14] = onLinkCardActionsActiveChange;
    $[15] = onQuoteClick;
    $[16] = onSave;
    $[17] = setActivePartIndex;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="tw-relative tw-flex tw-h-full tw-gap-x-3"><div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-self-center sm:tw-self-start"><div>{t6}{t7}</div></div></div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
export default WaveDropPartDrop;